import { render } from "./Upload.vue?vue&type=template&id=b41d5396&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=ts"
export * from "./Upload.vue?vue&type=script&lang=ts"

import "./Upload.vue?vue&type=style&index=0&id=b41d5396&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b41d5396"

export default script